<template>
      <el-form :model="form" :rules="rules" ref="ruleForm" status-icon v-loading="loading" size="small" >
        <el-form-item label="文章标题" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="文章分类" :label-width="formLabelWidth" prop="lx">
          <el-button type="primary" @click="showlx = !showlx">{{form.lx}}</el-button>
          <transition name="el-fade-in-linear">
            <el-radio-group v-show="showlx" v-model="form.lx">
              <el-radio-button label="公司通知"></el-radio-button>
              <el-radio-button label="事故案例"></el-radio-button>
              <el-radio-button label="操作规程"></el-radio-button>
              <el-radio-button label="专业知识"></el-radio-button>
            </el-radio-group>
          </transition>
        </el-form-item>

      <el-form-item label="关联类型" :label-width="formLabelWidth" prop="glcl">
        <el-select v-model="form.gllx" multiple filterable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="阅读时间" :label-width="formLabelWidth" prop="time">
        <el-input-number v-model="form.time" controls-position="right" :min="1" :max="100"></el-input-number>
      </el-form-item>

      <el-form-item label="文章状态" :label-width="formLabelWidth" prop="zt">
          <el-radio-group v-model="form.zt">
            <el-radio-button label="正常" ></el-radio-button>
            <el-radio-button label="草稿"></el-radio-button>
            <el-radio-button label="归档"></el-radio-button>
          </el-radio-group>
            <el-upload
              class="upload-demo"
              name="video"
              action="/apis/uploadphoto.php"
              :data="uploadData"
              :before-upload='upBefore'
              :on-success='upScuccess'
              :on-error='upError'
              ref="upload">
              <el-button size="mini" type="primary" id="imgInput" element-loading-text="插入中,请稍候" style="display:none">点击上传</el-button>
            </el-upload>
      </el-form-item>

          <el-form-item label="文章内容" :label-width="formLabelWidth" prop="text">
            <div class="edit_container">
              <quill-editor ref="myQuillEditor"
                v-model="form.text"
                :options = "editorOption">
              </quill-editor>
            </div>
          </el-form-item>

          <el-form-item label="" :label-width="formLabelWidth">
            <el-form-item>
              <el-button size="small" type="primary" :loading="loading" @click="submitForm('ruleForm')">确认提交</el-button>
            </el-form-item>
          </el-form-item>
      </el-form>

</template>

<script>
  import {quillEditor, Quill} from 'vue-quill-editor'
  import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'

  Quill.register('modules/ImageExtend', ImageExtend)
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  //import 'quill/dist/quill.bubble.css'
export default {
    data () {
      var checkLx = (rule, value, callback) => {
        if (value === '未分类') {
          callback(new Error('请选择分类'));
        } else {
          callback();
        }
      };
      return {
        addRange:new Array(),
        uploadData:{
          token:'vqgU1wqtfzcZRAniU',
          admin:this.$store.getters.name,
          my:this.$store.getters.token
        },
        showlx:false,
        loading:false,
        form:{
          name:'',
          lx:'未分类',
          gllx:['全部'],
          text:'',
          zt:'草稿',
          time:10
        },
        options:[
            { text: '全部', value: '全部' }, 
            { text: '1类 爆炸品', value: '1类 爆炸品' }, 
            { text: '2类1项 易燃气体', value: '2类1项 易燃气体'}, 
            { text: '2类2项 不燃气体', value: '2类2项 不燃气体' },
            { text: '2类3项 有毒气体', value: '2类3项 有毒气体'}, 
            { text: '3类 易燃液体', value: '3类 易燃液体'}, 
            { text: '4类1项 易燃固体', value: '4类1项 易燃固体'}, 
            { text: '4类2项 自燃物品', value: '4类2项 自燃物品'}, 
            { text: '4类3项 遇湿易燃物品', value: '4类3项 遇湿易燃物品'}, 
            { text: '5类1项 氧化剂', value: '5类1项 氧化剂'},
            { text: '5类2项 有机过氧化物', value: '5类2项 有机过氧化物'},
            { text: '6类1项 毒害品', value: '6类1项 毒害品'},
            { text: '6类2项 感染性物品', value: '6类2项 感染性物品'},
            { text: '7类 放射性物品', value: '7类 放射性物品'},
            { text: '8类 腐蚀品', value: '8类 腐蚀品'},
            { text: '9类 杂类', value: '9类 杂类'},
            { text: '危险废物', value: '危险废物'},
            { text: '普通货物运输', value: '普通货物运输'},
            { text: '旅客运输', value: '旅客运输'}
          ],
        editorOption:{
                    modules:{
                        ImageExtend: {
                          loading: true,
                          name: 'img',
                          size: 2,
                          action: '/apis/uploadphoto.php',
                          response: (res) => {
                            this.ret = res;
                            return res;
                          },
                          sizeError: () => {this.$message.error('图片大小不要超过2M')},  // 图片超过大小的回调
                          start: () => {this.$message('正在上传……');},
                          error: () => {this.$message.error('图片上传失败')},  // 可选参数 上传失败触发的事件
                          success: () => {
                            // console.log(this.ret);
                            if (this.ret == "token错误" || this.ret == "只能上传图片类型格式") this.$message.error(this.ret);
                            else this.$message.success('图片上传成功')
                          },  // 可选参数  上传成功触发的事件
                          change: (xhr, formData) => {
                            formData.append('token','pqgU1wqtfzcZRAniU')
                          }
                        },
                         toolbar: {  // 如果不上传图片到服务器，此处不必配置
                             container: [
                                [{ 'size': ['small', false, 'large', 'huge'] }], 
                                [{ 'color': [] },{ 'align': [] }],
                                ['bold', 'italic', 'underline', 'strike'], 
                                ['link','image','video']
                              ],
                             handlers: {
                                 'image': function () {  // 劫持原来的图片点击按钮事件
                                     QuillWatch.emit(this.quill.id)
                                 },
                             }
                         }
                    }
        },
        formLabelWidth: '80px',
        rules:{
          name: [
            { required: true, message: '请输入文章标题', trigger: 'blur' }
          ],
          lx: [
            { validator:checkLx, trigger: 'change' }
          ],
        }
      }
    },
    mounted(){
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler)  // 为视频ICON绑定事件
    },
    methods:{
      upBefore(file){
        if(file.size > 200*1024*1024) {
          this.$message.error("文件大小不要超过200M");
          return false;
        }
      },
      upError(err, file, fileList){
        console.log(err);
      },
      // 图片上传成功回调   插入到编辑器中
      upScuccess(url, file, fileList) {
        console.log(url);
        if (url.indexOf('token') > -1) {this.$message.error("视频大小不要超过200M");return;}
        if (url.indexOf('只能上传视频格式') > -1) {this.$message.error(url);return;}
          this.$message.success('视频上传成功')
          let vm = this
          if (url != null && url.length > 0) {  // 将文件上传后的URL地址插入到编辑器文本中
            let value = url
            vm.addRange = vm.$refs.myQuillEditor.quill.getSelection()
            value = value.indexOf('http') !== -1 ? value : 'http:' + value
            vm.$refs.myQuillEditor.quill.insertEmbed(vm.addRange !== null ? vm.addRange.index : 0, 'video', value, Quill.sources.USER)   // 调用编辑器的 insertEmbed 方法，插入URL
          } else {
            this.$message.error('视频插入失败');
          }
          this.$refs['upload'].clearFiles()    // 插入成功后清除input的内容
      },
      // 点击视频ICON触发事件
      videoHandler(state) {
        this.addRange = this.$refs.myQuillEditor.quill.getSelection()
        if (state) {
          let fileInput = document.getElementById('imgInput')
          fileInput.click() // 加一个触发事件
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message({showClose: true,message: '提交中……'});
            this.addText();
          } else {
            this.$message({showClose: true,message: '请检查内容',type: 'warning'});
            return false;
          }
        });
      },
      addText(){
        this.loading = true;
        var params = new URLSearchParams();
        params.append('token', 'zqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('name', this.form.name);
        params.append('lx', this.form.lx);
        params.append('gllx', this.form.gllx);
        params.append('time', this.form.time);
        params.append('zt', this.form.zt);
        params.append('text', this.form.text);
        this.$ajax.post("/apis/text.php",params).then((ret) => {
            // console.log(ret);
            this.loading = false;
            if (ret.data == true) {
              // console.log(this.form);
              this.$message({showClose: true,message: '已添加',type: 'success'});
              this.$store.state.forceFresh = true;
              this.$router.push('/text');
            }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      }
    },
    components: {
    //使用编辑器
      quillEditor
    },
    created(){
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.ql-snow .ql-picker{
  height: 35px;
}
.ql-snow .ql-picker.ql-size{
  height: 41px;
}
.upload-demo{
  margin-top:-30px;
}

.el-select{
  width: 90%;
}
</style>


// WEBPACK FOOTER //
// src/components/Addt.vue